import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import {
  ManagementMasterBillModel,
  ManagementMasterBillSearchModel,
  ManagementUpdateMasterBillModel,
  ManagementVoyageModel,
} from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class MasterBillsRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params?: ManagementMasterBillSearchModel,
    isShowLoader?: boolean,
    isUsed: boolean = false,
  ): Observable<PaginatedResultModel<ManagementMasterBillModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementMasterBillModel>>(
      environment.url.freight.masterBillsManagement,
      { params },
      { isShowLoader, isUsed },
    );
  }

  public searchByVoyageId(
    voyageId: ManagementVoyageModel['id'],
    params: PaginationSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementMasterBillModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementMasterBillModel>>(
      `${environment.url.freight.voyagesManagement}/${voyageId}/master-bills`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public create(
    voyageId: ManagementVoyageModel['id'],
    model: ManagementUpdateMasterBillModel,
    isShowLoader?: boolean,
  ): Observable<ManagementMasterBillModel> {
    return this.apiService.post<ManagementMasterBillModel>(
      `${environment.url.freight.voyagesManagement}/${voyageId}/master-bills`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }

  public get(id: ManagementMasterBillModel['id'], isShowLoader?: boolean): Observable<ManagementMasterBillModel> {
    return this.apiService.get<ManagementMasterBillModel>(`${environment.url.freight.masterBillsManagement}/${id}`, null, { isShowLoader });
  }

  public update(
    id: ManagementMasterBillModel['id'],
    model: ManagementUpdateMasterBillModel,
    isShowLoader?: boolean,
  ): Observable<ManagementMasterBillModel> {
    return this.apiService.put<ManagementMasterBillModel>(`${environment.url.freight.masterBillsManagement}/${id}`, model, null, {
      isShowLoader,
    });
  }

  public delete(id: ManagementMasterBillModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.masterBillsManagement}/${id}`, null, { isShowLoader });
  }
}
